import React from 'react';
import '../../../less/index.less';
import '../less/apc.less';
import hero_img from '../img/hero_img.svg';
import Hero from '../../../../../../../auxiliary-components/shared/HeroBlock';
import BusinessOrder from '../../../../../../BusinessOrder';
import hero_data from '../enums/hero_data.json';
import AdditionalProduct from './../../../../../../../auxiliary-components/shared/AdditionalProductBlock';
import additional_cards from '../enums/additional_cards_data.json';
import { getUrl } from "utils/corploansUrl";
import { govApcConditionsLink, govApcUsageLink } from '../../../../../../../services/urls/urls';
import serviceUsageItems from '../enums/service_usage_items.json';

export default function template() {
    const page = 'business-gov-apc';
      
    const handlersMap = {
      toggleHeroModal: () => this.toggleModal(),
    };

    const linksMap = {
      corploansDefaultLink: getUrl()
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const additionalCards = additional_cards.map(item => ({
      ...item,
      link: linksMap[item.link]
    }));

    return (
      <div className="business-gov-apc">
        <Hero
          data={heroData}
          img={hero_img}
          svg
          page={page}
          className="gov-programs"
        />
        <div className="content">
          <div className="we-support">
            <div className="container">
              <h2 className="we-support__title">{this.l10n('BUSINESS_GOV_APC_NEW_WE_SUPPORT_TITLE')}</h2>
              <div className="we-support__text">{this.l10n('BUSINESS_GOV_APC_NEW_WE_SUPPORT_TEXT')}</div>
              <h2 className="we-support__title we-support__title_conditions">{this.l10n('BUSINESS_GOV_APC_NEW_CONDITIONS_TITLE')}</h2>
              <div className="we-support__text">{this.l10n('BUSINESS_GOV_APC_NEW_CONDITIONS_TEXT')}</div>
              <a className="we-support__btn" href={govApcConditionsLink} target="_blank" rel="noopener noreferrer">
                {this.l10n('BUSINESS_GOV_APC_NEW_CONDITIONS_BTN')}
              </a>
            </div>
          </div>
          <div className="service-usage">
            <div className="container">
              <h2 className="service-usage__title">{this.l10n('BUSINESS_GOV_APC_NEW_SERVICE_USAGE_TITLE')}</h2>
              <div className="service-usage__body">
                {serviceUsageItems.map((item, index) => (
                  <div key={index} className="service-usage__item item-service-usage">
                    <div className="item-service-usage__title">{this.l10n(item.title)}</div>
                    <div className="item-service-usage__text">
                      {item.text && this.l10n(item.text)}
                      {item.link && (
                        <a href={govApcUsageLink} target="_blank" rel="noopener noreferrer">
                          {this.l10n(item.link)}
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="service-usage__text">{this.l10n('BUSINESS_GOV_APC_NEW_SERVICE_USAGE_TEXT')}</div>
            </div>
          </div>
          <AdditionalProduct
            items={additionalCards}
            title={'BUSINESS_GOV_APC_NEW_ADDITIONAL_PRODUCT_TITLE'}
            page={page}
          />
        </div>
        {this.state.showModal && <BusinessOrder attribute="apc" closeModal={this.toggleModal} />}
      </div>
    );
}
